import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProfile, updateProfile } from "store/auth/profile/profileSlice";
import { Form, Input, DatePicker, Button, Row, Col, Card, Typography, message, Select } from "antd";
import moment from "moment";

const { Title } = Typography;

const ProfileEditForm = ({ handleCancel }) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.Profile.profile);
  const [form] = Form.useForm();
  const [experience, setExperience] = useState('')
  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  // Pre-fill the form with profile data when it's available
  useEffect(() => {
    if (profile) {
      form.setFieldsValue({
        lastName: profile.lastName,
        firstName: profile.firstName,
        dateOfBirth: moment(profile.dateOfBirth), // Convert to moment object for DatePicker
        email: profile.email,
        phone: profile.phone,
        username: profile.username,
        currentClub: profile.currentClub,
        position: profile.position,
        niveauExperience: profile.niveauExperience,
        category: profile.category,
      });
    }
  }, [profile, form]);

  // Handle form submission
  const onFinish = (values) => {
    // Format dateOfBirth to a string before sending to the backend
    const formattedValues = {
      ...values,
      dateOfBirth: values.dateOfBirth.format("YYYY-MM-DD"),
    };

    dispatch(updateProfile(formattedValues))
      .unwrap()
      .then(() => {
        message.success("Profile updated successfully!");
        handleCancel()
      })
      .catch(() => {
        message.error("Failed to update profile.");
      });
  };

  return (
    <Card
      style={{
        borderRadius: "10px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Nom"
              name="lastName"
              rules={[{ required: true, message: "Please enter your last name" }]}
            >
              <Input placeholder="Enter your last name" />
            </Form.Item>

            <Form.Item
              label="Prénom"
              name="firstName"
              rules={[{ required: true, message: "Please enter your first name" }]}
            >
              <Input placeholder="Enter your first name" />
            </Form.Item>

            <Form.Item
              label="Date de naissance"
              name="dateOfBirth"
              rules={[{ required: true, message: "Please select your date of birth" }]}
            >
              <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item
              label="E-mail"
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              label="Numéro de téléphone"
              name="phone"
              rules={[{ required: true, message: "Please enter your phone number" }]}
            >
              <Input placeholder="Enter your phone number" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="Nom d’utilisateur"
              name="username"
              rules={[{ required: true, message: "Please enter your username" }]}
            >
              <Input placeholder="Enter your username" />
            </Form.Item>

            <Form.Item
              label="Club actuel"
              name="currentClub"
              rules={[{ required: true, message: "Please enter your current club" }]}
            >
              <Input placeholder="Enter your current club" />
            </Form.Item>

            <Form.Item
              label="Poste"
              name="position"
              rules={[{ required: true, message: "Please enter your position" }]}
            >
              <Select>
                <option value='Forward'> Forward</option>
                <option value='Midfielder'> Midfielder</option>
                <option value='Defender'> Defender</option>
                <option value='Goalkeeper'> Goalkeeper</option>
              </Select>
              {/* <Input placeholder="Enter your position" /> */}
            </Form.Item>

            <Form.Item
              label="Niveau d'expérience"
              name="experienceLevel"
            //   rules={[{ required: true, message: "Please enter your experience level" }]}
            >
              <Select
                placeholder="Enter your experience level"
                onChange={(value) => setExperience(value)}
                value={experience}
              >
                <option value='Amateur'>Amateur</option>
                <option value='Professional'>Professional</option>
                <option value='semi-pro'>Semi-pro</option>
                <option value='Other'>Other</option>
              </Select>
            </Form.Item>
            {experience == "Other" && (
              <Form.Item
                label="experience Details"
                name="experienceDetails"
                rules={[{ required: true, message: "Please enter your experience" }]}
              >
                <Input placeholder="Enter your current club" />
              </Form.Item>
            )}

            <Form.Item
              label="Catégorie"
              name="category"
              rules={[{
                required: true,
                message: "Veuillez sélectionner votre catégorie"
              }]}
            >
              <Select placeholder="Sélectionnez une catégorie">
                <Select.Option value="u14-u15">U14-U15</Select.Option>
                <Select.Option value="u16-u17">U16-U17</Select.Option>
                <Select.Option value="u18-u19">U18-U19</Select.Option>
                <Select.Option value="u20-u21">U20-U21</Select.Option>
                <Select.Option value="seniors">Seniors</Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end">
          <Col>
            <Button type="primary" htmlType="submit">
              Save Changes
            </Button>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default ProfileEditForm;